// globalMixin.js
import store from '@/store'; // 引入 Vuex store
export default {
  methods: {
  
  }
};